module.exports = __webpack_public_path__ + "img/upload-photo.a82a24c6.svg";